/**
 * Files Cache Module - Deprecated Shim
 * 
 * This file is deprecated. Import from './files-cache/index.js' instead.
 * Kept for backward compatibility during migration period.
 * 
 * Refactored structure:
 * - files-cache/local-storage-manager.js: localStorage operations
 * - files-cache/files-loader.js: file and summaries loading
 * - files-cache/filter-metadata-generator.js: filter metadata generation
 * - files-cache/index.js: orchestrator
 */

import { filesCacheManager } from './files-cache/index.js';

// Re-export for backward compatibility
export { filesCacheManager };

// Global export for backward compatibility
window.filesCacheManager = filesCacheManager;
